import Button from "../../Button";
import React, { useContext } from "react";
import constants from "../../../constants";
import InfoSvg from "../../../Svg/InfoSvg";
import { getDataFromStorage } from "../../../util";
import ResetSvgIcon from "../../../Svg/ResetSvgIcon";
import AlertContext from "../../../context/AlertContext";
import ThumbUpsSvgIcon from "../../../Svg/ThumbUpsSvgIcon";
import WebSocketHooks from "../../../Hooks/WebSocketHooks";
import RightArrowSvgIcon from "../../../Svg/RightArrowSvgIcon";
import WarningSvg from "../../Notification-Loading/Notify/Svg/WarningSvg";
import mobileCameraView from "../../../assets/images/mobileCameraView.png";
import CameraPlacementHooks from "../../../Hooks/InstructionPage/CameraPlacementHooks";
import MobileViewSetUpHooks from "../../../Hooks/InstructionPage/MobileViewSetUpHooks";
import InstructionPageWizardHooks from "../../../Hooks/InstructionPage/InstructionPageWizardHooks";

export default function CameraPlacement() {
  const Alert = useContext(AlertContext);

  WebSocketHooks();

  const MobileViewSetUpHks = MobileViewSetUpHooks();
  const CameraPlacementHks = CameraPlacementHooks();
  const InstructionPageWizardHks = InstructionPageWizardHooks();

  return (
    <div className="cameraPlacementMainContainer">
      Position Your Phone Camera
      <div className="cameraPlacementDesc">
        <div className="cameraPlacementDescText">
          Now that your phone is connected, position it to clearly show:
          <ol className="cameraPlacementDescTextOl">
            <li>Your face from the side. </li>
            <li>Your laptop screen. </li>
            <li>The background behind you.</li>
          </ol>
        </div>
        <img
          src={mobileCameraView}
          alt="mobileCameraView"
          className="cameraPlacementDescTextMobileView"
        />
      </div>
      <div className="cameraPlacementBodyLabel">Your Phone Camera view</div>
      <div className="cameraPlacementBody">
        <div className="cameraPlacementBodyImgDiv">
          <img
            alt="mobileCameraView"
            className="cameraPlacementBodyImg"
            src={Alert.verifyImg || mobileCameraView}
          />
          <Button
            size="sm"
            icon={{ type: "leading", icon: <ResetSvgIcon type={2} /> }}
            onClick={() =>
              CameraPlacementHks.verifyPic(
                `${MobileViewSetUpHks.folderName()}/setup/${getDataFromStorage(
                  "learnerid"
                )}.png`
              )
            }
            hierarchy={{
              type: "secondaryGrey",
              buttonText: "Check Camera Alignment",
            }}
          />
          {CameraPlacementHks.cameraPlacementDetail?.status && (
            <div className="cameraPlacementBodyErr">
              {CameraPlacementHks.cameraPlacementDetail.status ===
              constants.RESULT_STATUS.SUCCESS ? (
                <ThumbUpsSvgIcon />
              ) : CameraPlacementHks.cameraPlacementDetail.status ===
                constants.RESULT_STATUS.FAILURE_ATTEMPT ? (
                <InfoSvg component="notify" />
              ) : (
                <WarningSvg component="interview" />
              )}
              {CameraPlacementHks.cameraPlacementDetail.msg}
            </div>
          )}
        </div>
        <Button
          size="sm"
          onClick={InstructionPageWizardHks.handleNext}
          disable={CameraPlacementHks.cameraPlacementDetail.button}
          icon={{ type: "trailing", icon: <RightArrowSvgIcon type={2} /> }}
          hierarchy={{
            type: "primary",
            buttonText: "Proceed",
          }}
        />
      </div>
    </div>
  );
}
